export const BATCH_SMS_GENERATED_USER_MESSAGE = 'BATCH_SMS_GENERATED_USER_MESSAGE';